import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import React, { useEffect, useRef } from 'react';

export interface MediaPlayerProps {
  url: string;
  autoplay?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClose?: () => void;
  showCloseButton?: boolean;
}

const MediaPlayer: React.FC<MediaPlayerProps> = ({
  url,
  autoplay = false,
  className = '',
  style = {},
  onClose,
  showCloseButton = false,
}) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (audioRef.current) {
      // Load the new source
      audioRef.current.load();

      // If autoplay is enabled, start playing
      if (autoplay) {
        audioRef.current.play().catch((error) => {
          console.warn('Autoplay failed:', error);
        });
      }
    }
  }, [autoplay, url]);

  return (
    <div className={`media-player-container ${className}`} style={style}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ flex: 1 }}>
          <audio ref={audioRef} controls preload="metadata" style={{ width: '100%' }}>
            <source src={url} type="audio/mpeg" />
            <source src={url} type="audio/ogg" />
            <source src={url} type="audio/wav" />
            Your browser does not support the audio element.
          </audio>
        </Box>
        {showCloseButton && onClose && (
          <IconButton
            onClick={onClose}
            size="small"
            sx={{
              color: 'text.secondary',
              '&:hover': {
                color: 'text.primary',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </div>
  );
};

export default MediaPlayer;
